module.exports = __webpack_public_path__ + "media/images/locations/circle/india-fe0f83cf2eb31307cdb5a33279db5314.jpg";